import { render } from "./SchedaAzienda.vue?vue&type=template&id=ec5d669e&scoped=true"
import script from "./SchedaAzienda.vue?vue&type=script&lang=js"
export * from "./SchedaAzienda.vue?vue&type=script&lang=js"

import "./SchedaAzienda.vue?vue&type=style&index=0&id=ec5d669e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5d669e"]])

export default __exports__